import { createFileRoute } from '@tanstack/react-router';
import { AccountBilling } from '../../pages/account/AccountBilling';

export const Route = createFileRoute('/dashboard/billing')({ component: AccountBilling });
